// src/components/CookieConsent.js
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const COPY = {
  title: {
    en: "Cookie notice",
    pl: "Informacja o cookies",
    es: "Aviso de cookies",
  },
  text: {
    en: "We use cookies to ensure that we give you the best experience on our website. By continuing to use our site, you accept our cookie policy.",
    pl: "Uzywamy cookies, aby zapewnic najlepsze doswiadczenie na naszej stronie. Kontynuujac korzystanie z witryny, akceptujesz polityke cookies.",
    es: "Usamos cookies para ofrecer la mejor experiencia en nuestro sitio web. Al continuar usando la web, aceptas nuestra politica de cookies.",
  },
  policy: {
    en: "Cookie Policy",
    pl: "Polityka cookies",
    es: "Politica de cookies",
  },
  reject: { en: "Reject", pl: "Odrzuc", es: "Rechazar" },
  accept: { en: "Accept", pl: "Akceptuj", es: "Aceptar" },
};

const CookieConsent = () => {
  const { pick } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) setIsVisible(true);
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setIsVisible(false);
  };

  const handleReject = () => {
    Cookies.set("cookieConsent", "rejected", { expires: 365 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const css = `
    .ch-cookie-overlay{
      position: fixed;
      inset: 0;
      z-index: 9999;
      background: rgba(0,0,0,0.72);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }

    .ch-cookie-modal{
      width: min(720px, 96vw);
      background: rgba(10,10,10,0.92);
      color: #ffffff;
      border: 1px solid rgba(255,255,255,0.14);
      border-radius: 18px;
      padding: 18px 18px 16px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.55);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
    }

    .ch-cookie-title{
      font-size: 1.05rem;
      font-weight: 900;
      margin: 0 0 10px 0;
      letter-spacing: 0.2px;
    }

    .ch-cookie-text{
      margin: 0;
      line-height: 1.55;
      color: rgba(255,255,255,0.92);
      font-size: 0.98rem;
    }

    .ch-cookie-footer{
      margin-top: 10px;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    }

    .ch-cookie-link{
      color: rgba(255,255,255,0.9);
      text-decoration: underline;
      font-weight: 800;
    }
    .ch-cookie-link:hover{
      color: #ffffff;
    }

    .ch-cookie-actions{
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: flex-end;
    }

    .ch-cookie-btn{
      appearance: none;
      border-radius: 12px;
      padding: 10px 14px;
      font-weight: 900;
      border: 1px solid rgba(255,255,255,0.22);
      cursor: pointer;
      line-height: 1;
      transition: transform 0.12s ease, opacity 0.12s ease;
      user-select: none;
    }
    .ch-cookie-btn:active{
      transform: scale(0.98);
    }

    .ch-cookie-btn-accept{
      background: #ffffff;
      color: #111111;
      border-color: #ffffff;
    }

    .ch-cookie-btn-reject{
      background: rgba(255,255,255,0.06);
      color: #ffffff;
    }

    .ch-cookie-copy{
      margin-top: 10px;
      font-size: 0.9rem;
      color: rgba(255,255,255,0.7);
    }

    @media (max-width: 520px){
      .ch-cookie-modal{ padding: 16px; }
      .ch-cookie-footer{ justify-content: center; }
      .ch-cookie-actions{ width: 100%; justify-content: center; }
      .ch-cookie-btn{ width: 100%; }
    }
  `;

  return (
    <>
      <style>{css}</style>

      <div className="ch-cookie-overlay" role="dialog" aria-modal="true">
        <div className="ch-cookie-modal">
          <div className="ch-cookie-title">{pick(COPY.title)}</div>

          <p className="ch-cookie-text">{pick(COPY.text)}</p>

          <div className="ch-cookie-footer">
            <Link className="ch-cookie-link" to="/cookie-policy">
              {pick(COPY.policy)}
            </Link>

            <div className="ch-cookie-actions">
              <button
                className="ch-cookie-btn ch-cookie-btn-reject"
                onClick={handleReject}
                type="button"
              >
                {pick(COPY.reject)}
              </button>
              <button
                className="ch-cookie-btn ch-cookie-btn-accept"
                onClick={handleAccept}
                type="button"
              >
                {pick(COPY.accept)}
              </button>
            </div>
          </div>

          <div className="ch-cookie-copy">© 2024 ChessHood.com</div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
